import React from 'react';
import YoutubePlayer from './youtubeplayer';


function Youtube() {
    return ( 
        <div>
            <h3>Youtube video list</h3>
            <YoutubePlayer id="3zh9Wb1KuW8"></YoutubePlayer>
            <YoutubePlayer id="BDLChveBsRk"></YoutubePlayer>
            <YoutubePlayer id="dQ8YIGKqXLw"></YoutubePlayer>
            <YoutubePlayer id="V9_ZpqfqHFI"></YoutubePlayer>
        </div>
     );
}

export default Youtube;